import { mapGetters } from 'vuex';

export default {
    name: 'dppBanner',
    inject: ['$eventBus'],
    props: {
        pageName: String,
    },
    data() {
        return {
            getVisitTimings: {
                isCutOffPassed: false,
                displayTimings: [],
            },
        };
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        ...mapGetters('dpp', ['dpp', 'getEstRentFee', 'getMonthTotal']),
        showPriceDropBanner() {
            return this.dpp.isPriceReduced && this.dpp.showPriceChange;
        },
        goodInvestment() {
            if (this.dpp.isRentals || !this.dpp.isActive) {
                return false;
            }
            if (this.getEstRentFee && this.getMonthTotal && (this.dpp.closePrice > 0 || this.dpp.listPrice > 0)) {
                return this.getEstRentFee.value > this.getMonthTotal;
            }
            return false;
        },
        hotMarket() {
            return this.dpp.avgPendingDays > 0 && this.dpp.avgPendingDays <= 28 && (this.dpp.isActive || this.dpp.isSold || this.dpp.isPrOnly);
        },
        leftOverDays() {
            return this.dpp.daysOnMovoto ? 15 - this.dpp.daysOnMovoto : 15;
        },
        priceReducedBy() {
            if (this.dpp.priceHistory && this.dpp.priceHistory[0] && this.dpp.priceHistory[0].change) {
                return this.dpp.priceHistory[0].change !== '—' ? `(${this.dpp.priceHistory[0].change})` : '';
            }
            return '';
        },
    },
    methods: {
        getHotleadForBox() {
            let hotleadType = '';
            if (this.goodInvestment) {
                hotleadType = 'InvestmentOpportunity';
            } else if (this.showPriceDropBanner) {
                hotleadType = 'PriceDrop';
            } else if (this.hotMarket) {
                hotleadType = 'HotMarket';
            }
            return hotleadType;
        },
        openMpickPop() {
            this.$eventBus.$emit('property-pop-hot', {
                title: '<span class="text-danger text-bold">Good Bones</span>',
                content:
                    "The pricing of this home is competitive based on its price per square foot. By performing upgrades and renovations, this property has the potential to build more equity than others in the area. However, it's important to note that this information alone does not provide a definitive indication of the property's true market value. It should be evaluated alongside other important factors before making a final decision.",
            });
        },
        openHotPop() {
            this.$eventBus.$emit('property-pop-hot', {
                title: 'This home is <span class="text-red">HOT</span>',
                content:
                    'Movoto detects listings that are likely to sell fast so you’re able to act quickly on a home that fits your needs. Our algorithm identifies homes that are hot by analyzing the latest local market data, including average days on market, list price, property type, location, home features, and more.',
            });
        },
        openHotMarketPop() {
            this.$eventBus.$emit('property-pop-hot', {
                title: this.dpp.avgPendingDays > 14 ? 'This market is <span class="text-red">HOT</span>' : 'This market is <span class="text-red">VERY HOT</span>',
                content:
                    'Movoto identifies the most active markets by analyzing the latest listing data. Our algorithm has determined this market is HOT based on a low average days on market for new listings.',
            });
        },
        openhotlead1(buttonText) {
            this.$eventBus.$emit('property-pop-schedule', {
                date: new Date(),
                hotleadType: this.getHotleadForBox() || 'openHouseCalendarHotlead',
                changeDate: true,
                trigger: this.$options.name,
                buttonText: buttonText || 'Request Tour',
            });
        },
        popTourHotlead(e) {
            this.popHotlead(e, true);
        },
        popHotHomelead(e) {
            this.popHotlead(e, false);
        },
        popSoldlead(title, cta, type) {
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtHotleadForm',
                trigger: this.$options.name,
                opt: {
                    hotleadTitle: title || ' ',
                    hotleadType: type || 'hotHomeHotLead',
                    buttonText: cta || 'Send Request',
                    showComment: false,
                    propertyId: this.dpp.propertyId,
                    propertyData: this.dpp,
                },
            });
        },
        popHotlead(e, isReqTour = true) {
            let hotleadOpt = {
                hotleadType: this.getHotleadForBox() || 'hotHomeHotLead',
                propertyId: this.dpp.propertyId,
                propertyData: this.dpp,
                showComment: false,
            };
            if (isReqTour) {
                let timeTxt = e.target.innerText;
                let today = new Date();
                var tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);
                hotleadOpt.date = this.getVisitTimings.isCutOffPassed ? tomorrow : today;
                hotleadOpt.time = timeTxt;
                hotleadOpt.hotleadTitle = 'Request Tour';
            } else {
                hotleadOpt.hotleadTitle = 'Hot Home';
            }
            if (this.dpp && !this.dpp.isActive) {
                hotleadOpt.hotleadTitle = ' ';
                hotleadOpt.buttonText = 'Send Request';
            }
            if (this.glb.agent.id && !this.glb.rentals) {
                hotleadOpt.ojoFormConfigs = {
                    showCtaLinks: false,
                    showOJOagentInfo: true,
                    showDisclaimer: false,
                    commnetLabel: 'Message',
                };
            }
            this.$eventBus.$emit('dialog-center', { name: 'mvtHotleadForm', trigger: this.$options.name, opt: hotleadOpt });
        },
        setVisitTimings() {
            let now = new Date();
            const startTime = 9;
            const endTime = 17;
            const hrs = now.getHours();
            const isCutOffPassed = hrs >= endTime;
            let len = 2;
            let visitTime, displayStartTime;
            let displayTimings = [];
            visitTime = now.getMinutes() > 0 ? hrs + 3 : hrs + 2;
            displayStartTime = visitTime < startTime || hrs >= endTime ? startTime : visitTime;
            len = displayStartTime > endTime ? (displayStartTime > 18 ? 1 : 2) : len;

            for (let i = 0; i < len; i++) {
                let txt = displayStartTime >= 12 ? ':00 pm' : ':00 am';
                let time = displayStartTime > 12 ? displayStartTime - 12 : displayStartTime;
                displayTimings[i] = `${time}${txt}`;
                displayStartTime++;
            }
            return {
                displayTimings,
                isCutOffPassed,
            };
        },
    },
    mounted() {
        this.getVisitTimings = this.setVisitTimings();
    },
};
